<template>
  <div
    id="confirmationModal"
    class="modal fade bs-example-modal-sm"
    tabindex="-1"
    role="dialog"
    aria-labelledby="mySmallModalLabel"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
          <h4 id="mySmallModalLabel" class="modal-title">
            Confirmação de Remoção
          </h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-2 col-xs-2">
              <i class="fa fa-exclamation-triangle fa-4x m-t-xs text-danger" />
            </div>
            <div class="col-xs-9 col-xs-offset-1 col-sm-10 col-sm-offset-0">
              <p class="lead">
                Tem certeza que deseja remover o item selecionado?
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-white" data-dismiss="modal">
            Cancelar
          </button>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RemoveModal'
}
</script>
